import "./ZoomedImage.scss";
import { useEffect, useState, Fragment } from "react";
import { API_URL } from "../../utils/axios";
import axios from "axios";
import Loading from "../../components/Loading/Loading";
import { Redirect } from "react-router-dom";

const ZoomedImage = (props) => {
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [comments, setComments] = useState("");
  const [loading, setLoading] = useState(true);
  const [deletedZommed, setDeletedZoomed] = useState(false);

  const showComment =
    comments &&
    comments.map((each) => {
      return (
        <div className="zoomed-image__comment" key={each._id}>
          <div className="zoomed-image__upper">
            <p className="zoomed-image__name">{each.name}</p>
            <p className="zoomed-image__date">
              {new Date(each.createdAt).toLocaleDateString()}
            </p>
          </div>
          <p className="zoomed-image__lower ">{each.comment}</p>
        </div>
      );
    });

  const fetchGalleryItem = (props) => {
    axios
      .get(API_URL + "/gallery/" + props.match.params.id)
      .then((response) => {
        console.log(response.data === null);
        console.log("fire");
        setComments(response.data.comments);
        setImage(response.data);
        setLoading(false);
        console.log(response.data === null);
        if (response.data === null) {
          setDeletedZoomed(true);
        }
      })
      .catch((error) => setDeletedZoomed(true));
  };

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleCommentsChange = (e) => {
    setComment(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(API_URL + "/gallery/" + props.match.params.id + "/comments", {
        name,
        comment,
      })
      .then((response) => {
        setComments(response.data.comments);
        setName("");
        setComment("");
      })
      .catch((error) => console.log(error));
  };

  const [image, setImage] = useState({});
  useEffect(() => {
    fetchGalleryItem(props);
  }, [setImage, props]);

  if (deletedZommed) {
    return <Redirect to="/gallery" />;
  }
  return (
    <div>
      {loading && <Loading />}
      {!loading && (
        <Fragment>
          <h1 className="zoomed-image__title"> GALLERY</h1>
          <div className="zoomed-image__container">
            <div className="zoomed-image__left">
              <img
                src={image.picture}
                alt="gallery"
                className="zoomed-image__image"
              />
              <div>
                <p className="zoomed-image__left--lower">{image.description}</p>
              </div>
            </div>
            <div className="zoomed-image__right">
              <form className="zoomed-image__form" onSubmit={handleSubmit}>
                <label htmlFor="nameInput">NAME</label>
                <input
                  className="zoomed-image__input"
                  type="text"
                  id="nameInput"
                  name="name"
                  placeholder="Name"
                  value={name}
                  onChange={handleNameChange}
                />
                <label
                  className="zoomed-image__comments--label"
                  htmlFor="comments"
                >
                  LEAVE A COMMENT
                </label>
                <textarea
                  className="zoomed-image__comments--new-comment"
                  id="comment"
                  name="comment"
                  placeholder="Write Comment Here"
                  value={comment}
                  onChange={handleCommentsChange}
                ></textarea>
                <button className="zoomed-image__button">SUBMIT</button>
              </form>

              <div className="zoomed-image__right--lower">{showComment}</div>
            </div>
          </div>
        </Fragment>
      )}
    </div>
  );
};

export default ZoomedImage;
